export default __webpack_public_path__ + "static/media/21.c9c03bc7.svg";